import Vue from 'vue'
import EventService from 'Services/EventService'

const initialState = JSON.stringify({
    event: {
        id: null,
        patient_id: null,
        office_id: null,
        start: '',
        end: '',
        type: 'mobile',
        mobile_street: null,
        mobile_city: null,
        patient: {},
        visit: {},
        office: {}
    },
    events: []
})

export default {

    state: Object.assign({}, JSON.parse(initialState)),

    getters: {
        event: state => state.event,
        events: state => state.events
    },

    mutations: {
        SET_EVENT(state, event) {
            state.event = event
        },
        SET_EVENTS(state, events) {
            state.events = events
        }
    },

    actions: {
        EVENTS_FETCH(context, query) {
            return EventService.list(query).then((result) => {
                context.dispatch('CREATE_PAGINATION', 1)
                context.commit('SET_EVENTS', result.data.data)
                return result
            })
        },
        EVENT_FETCH(context, data) {
            return EventService.get(data.id, data.query || null).then((result) => {
                context.commit('SET_EVENT', result.data.data)
                return result
            })
        },
        EVENT_STORE({state}, event = null) {
            return EventService.store(event || state.event)
        },
        EVENT_UPDATE({state}, event = null) {
            return EventService.update(event || state.event)
        },
        EVENT_DELETE(context, data) {
            return EventService.delete(data.id, data.query)
        },
        EVENT_RESET(context) {
            context.commit('SET_EVENT', JSON.parse(initialState).event)
        },
        EVENTS_RESET(context) {
            context.commit('SET_EVENTS', [])
        }
    }

}